const AGENT_UI_EVENT_PREFIX = 'agent_ui_wizard';
const createEventName = (name: string) =>
  `${AGENT_UI_EVENT_PREFIX}.${name}` as const;

export const AgentUIEventTypes = {
  JOURNEY_INIT: createEventName('journey_init'),
  NAVIGATION: {
    TRIGGERED: createEventName('navigation'),
  } as const,
  FILE_UPLOAD: {
    TRIGGERED: createEventName('file_upload'),
  },
  SUBSCRIPTION: {
    PURCHASE_POLLING: {
      STARTED: createEventName('subscription_purchase_polling_started'),
      COMPLETED: createEventName('subscription_purchase_polling_completed'),
    },
  },
  DEPLOYMENT: {
    VALIDATION: {
      STARTED: createEventName('deployment_validation_started'),
      FAILED: createEventName('deployment_validation_failed'),
      SUCCESS: createEventName('deployment_validation_success'),
    },
    PROCESSING: {
      STARTED: createEventName('deployment_status_processing_started'),
      FAILED: createEventName('deplayment_status_processing_failed'),
      COMPLETED: createEventName('deployment_status_processing_completed'),
    },
  },
} as const;

type ExtractEventTypes<T> = T extends { [key: string]: infer U }
  ? U extends string
    ? U
    : ExtractEventTypes<U>
  : never;

export type AgentUIEventName = ExtractEventTypes<typeof AgentUIEventTypes>;
export type EventProperties = Record<
  string,
  string | number | boolean | undefined
>;

export type CaptureEventFn = (
  eventName: AgentUIEventName,
  eventProperties?: EventProperties,
) => void;
